<template>
  <div id="deploy">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>
<script>
export default {
  name: 'deploy'
}
</script>




// WEBPACK FOOTER //
// src/views/process/deploy/Deploy.vue